import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import GridContainer from './GridContainer';
import './Grid.module.css';

class Grid extends PureComponent {
  render() {
    const {
      direction,
      gutters,
      primaryAlignment,
      secondaryAlignment,
      classes,
      styles,
      children,
      hasContainer,
      addStyleNames
    } = this.props;

    let styleNames = [`grid-${direction}`];
    if (gutters) {
      if (gutters === 'margin' || gutters === 'padding') {
        styleNames.push(`grid-${gutters}-${direction}`);
      }
    }
    if (primaryAlignment) {
      styleNames.push(primaryAlignment);
    }
    if (secondaryAlignment) {
      styleNames.push(secondaryAlignment);
    }
    if (addStyleNames) {
      const additionalStyles = addStyleNames.split(' ');
      styleNames = styleNames.concat(additionalStyles);
    }

    const grid = (
      <div
        className={classes}
        styleName={classNames(styleNames)}
        style={styles}
      >
        {children}
      </div>
    );

    if (hasContainer) {
      return <GridContainer>{grid}</GridContainer>;
    }

    return grid;
  }
}

Grid.propTypes = {
  /** The direction of the grid. */
  direction: PropTypes.oneOf(['x', 'y']).isRequired,
  /** Which type of gutter this grid this should have, if any. */
  gutters: PropTypes.oneOf(['margin', 'padding']),
  /** Default alignment behavior for cells in the primary direction. */
  primaryAlignment: PropTypes.oneOf([
    'align-right',
    'align-center',
    'align-justify',
    'align-spaced',
    'align-left',
    ''
  ]),
  /** Default alignment behavior for cells in the secondary direction. */
  secondaryAlignment: PropTypes.oneOf([
    'align-top',
    'align-middle',
    'align-bottom'
  ]),
  hasContainer: PropTypes.bool,
  classes: PropTypes.any,
  styles: PropTypes.any,
  children: PropTypes.any,
  addStyleNames: PropTypes.any
};

export default DisplayComponent(Grid);
